import { LineItemData as LineItemModel, WishlistLineItem } from '@api/types';
import { useAuth, useWishlist } from '@hooks';
import { useCart } from '@hooks/cart/cart.hooks';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Box, styled } from '@mui/material';
import { colors } from '@themes/colors';

// STYTLES
//---------

const IconBox = styled(Box)`
  cursor: pointer;
`;

/**
 * Order Item
 */
export type LineItemActionsProps = {
  lineItem?: LineItemModel;
};

/**
 * Line Item Actions
 */
export const LineItemActions = ({ lineItem = {} }: LineItemActionsProps) => {
  // BE request to remove item
  const { name, code = '' } = lineItem;
  const { isDealerUser, isOEMUser, isServiceUser } = useAuth();
  const { removeFromCart } = useCart();
  const deleteItemHandler = () => removeFromCart(code, name);
  const { addToWishlistHandler, removeFromWishlistHandler, wishlist } = useWishlist();
  const isInWishlist = wishlist?.some(
    (wishlistItem: WishlistLineItem) => wishlistItem.code === code
  );
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      {(isDealerUser || isOEMUser || isServiceUser) && (
        <IconBox className='line-item-wishlist'>
          {isInWishlist ? (
            <StarIcon
              onClick={() => removeFromWishlistHandler(code, name)}
              sx={{
                color: colors.primary.mainGreen,
              }}
            />
          ) : (
            <StarOutlineIcon
              onClick={() => addToWishlistHandler(code, name)}
              sx={{
                '&:hover': {
                  color: colors.primary.mainGreen,
                },
              }}
            />
          )}
        </IconBox>
      )}

      <IconBox>
        <DeleteOutline
          onClick={deleteItemHandler}
          sx={{
            '&:hover': {
              color: colors.secondary.red,
            },
          }}
        />
      </IconBox>
    </Box>
  );
};
